import {
  LiveChatColored as LiveChatIcon,
  HelpDeskColored as HelpDeskIcon,
  ChatBotColored as ChatBotIcon,
  KnowledgeBaseColored as KnowledgeBaseIcon,
  OpenWidgetColored as OpenWidgetIcon,
  PlatformColored as PlatformIcon,
  TextLogo as TextIcon,
  RosetteDiscountCheck as PartnerProgramIcon,
} from '@livechat/design-system-icons';

export const getLogoSource = (product: string) => {
  switch (product) {
    case 'LiveChat':
      return LiveChatIcon;
    case 'HelpDesk':
      return HelpDeskIcon;
    case 'ChatBot':
      return ChatBotIcon;
    case 'KnowledgeBase':
      return KnowledgeBaseIcon;
    case 'OpenWidget':
      return OpenWidgetIcon;
    case 'Platform':
      return PlatformIcon;
    case 'PartnerProgram':
      return PartnerProgramIcon;
    case 'Accounts':
    case 'TextApp':
    default:
      return TextIcon;
  }
};
